import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import config from 'utils/config';
import { getCoachAiName } from 'utils/i18n';
import Box from 'components/Box';
import Button from 'components/Button';
import CoachAiAvatar from 'components/Avatar/CoachAIAvatar';
import { COACH_AI_ROUTE } from '../../coach-ai';
import { SearchWidgetCard } from './SearchWidgetCard';
export function CoachAiLauncherWidget() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(SearchWidgetCard, {
    icon: /*#__PURE__*/React.createElement(CoachAiAvatar, null),
    title: getCoachAiName()
  }, /*#__PURE__*/React.createElement(Box, {
    as: "p",
    style: {
      whiteSpace: 'pre-wrap'
    }
  }, config.coachAiName ? t('coach_ai_teaser_with_name', {
    coachAiName: getCoachAiName()
  }) : t('coach_ai_teaser')), /*#__PURE__*/React.createElement(Button, {
    fullWidth: true,
    iconRight: "arrow-right",
    variant: "primary",
    as: Link,
    to: COACH_AI_ROUTE
  }, t('actions_give_it_a_try')));
}